import HTTP_BACK_OFFICE from '@/http';
import store from '@/store';
import auth from '@/utils/auth';

export default {
  testMetadatasFileType(context, formData) {
    return HTTP_BACK_OFFICE.post('/driver/metadatas/test', formData,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then(data => data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu lors du test des métadonnées<br>Erreur: ${error}` });
      });
  },

  testMetadata(context, formData) {
    return HTTP_BACK_OFFICE.post('/driver/metadata/test', formData,
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      })
      .then(data => data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu lors du test de la métadonnée<br>Erreur: ${error}` });
      });
  },

  checkUserAndUploadConf(context, params) {
    // eslint-disable-next-line max-len
    const requestParams = { userCheck: params.userCheck, metadatasConfiguration: params.configuration };

    console.log(`Sending data=> ${JSON.stringify(requestParams)}`);

    return HTTP_BACK_OFFICE.post(`driver/deskrh/admin/uploadConfiguration/${params.fileType}`, requestParams)
      .then((data) => {
        store.dispatch('app/openSnackbar', { message: 'La configuration a bien été envoyée sur DeskRH' });
        return data;
      })
      .catch((error) => {
        console.log(JSON.stringify(error.response.data.data));
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu lors du test des métadonnées<br>${JSON.stringify(error.response.data.data)}` });
      });
  },

  duplicateConfiguration(context, params) {
    const requestParams = { name: params.name, metadatas: params.metadatas };
    const userLogin = auth.getSessionUserLogin();

    return HTTP_BACK_OFFICE.post(`driver/metadatas/${userLogin}/${params.fileType}`, requestParams)
      .then((data) => {
        store.dispatch('app/openSnackbar', { message: 'La configuration a bien été dupliquée' });
        return data;
      })
      .catch((error) => {
        let message = '';
        if (error.toString().indexOf('code 409') !== -1) {
          message = `${requestParams.name} est déjà utilisé pour une configuration avec cet utilisateur et le type ${params.fileType}`;
        } else {
          message = `Un problème est survenu à l'enregistrement des informations<br>Erreur: ${error}`;
        }
        store.dispatch('app/openSnackbar', { message });
      });
  },

  saveMetadatas(context, params) {
    const tempMetadata = [];
    for (let i = 0; i < params.metadatas.length; i += 1) {
      tempMetadata[i] = {};
      for (let attrIndex = 0; attrIndex < Object.keys(params.metadatas[i]).length; attrIndex += 1) {
        if (!['hasPrefix', 'hasRegex', 'regexValue', 'prefixValue', 'metadata', 'testedValue']
          .includes(Object.keys(params.metadatas[i])[attrIndex])) {
          tempMetadata[i][Object.keys(params.metadatas[i])[attrIndex]] =
            params.metadatas[i][Object.keys(params.metadatas[i])[attrIndex]];
        }
      }
      if (params.metadatas[i].hasPrefix && params.metadatas[i].prefixValue) {
        tempMetadata[i].prefix = params.metadatas[i].prefixValue;
      }
      if (params.metadatas[i].hasRegex && params.metadatas[i].regexValue) {
        tempMetadata[i].regex = params.metadatas[i].regexValue;
      }
      if (params.metadatas[i].metadata.friendlyName) {
        tempMetadata[i].friendlyName = params.metadatas[i].metadata.friendlyName;
      }
      if (params.metadatas[i].metadata.tagName) {
        tempMetadata[i].tagName = params.metadatas[i].metadata.tagName;
      }
    }
    const requestParams = { name: params.name, metadatas: tempMetadata };
    const requestParamsUpdate = { name: params.name, metadatas: tempMetadata, id: params.id };
    const userLogin = auth.getSessionUserLogin();
    const testIt = (params.id === undefined)
      ? HTTP_BACK_OFFICE.post(`driver/metadatas/${userLogin}/${params.fileType}`, requestParams)
      : HTTP_BACK_OFFICE.put(`driver/metadatas/${userLogin}/${params.fileType}/${params.id}`, requestParamsUpdate);

    return testIt
      .then((data) => {
        store.dispatch('app/openSnackbar', { message: 'La configuration a bien été enregistrée' });
        return data;
      })
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu à l'enregistrement des informations<br>Erreur: ${error}` });
      });
  },

  getParseurs(context, params) {
    let url;
    const userLogin = auth.getSessionUserLogin();
    if (params && params.fileType) {
      url = `/driver/metadatas/${userLogin}/list?fileType=${params.fileType}`;
    } else {
      url = `/driver/metadatas/${userLogin}/list`;
    }
    return HTTP_BACK_OFFICE.get(url)
      .then(data => data.data.data)
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu, nous n'avons pas pu récupérer les configurations<br>Erreur: ${error}` });
      });
  },

  deleteConfig(context, [typeId, confId]) {
    const userLogin = auth.getSessionUserLogin();
    return HTTP_BACK_OFFICE.delete(`driver/metadatas/${userLogin}/${typeId}/${confId}`)
      .then(() => {
        store.dispatch('app/openSnackbar', { message: 'La configuration a bien été supprimée' });
      })
      .catch((error) => {
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu, la configuration n'a pas été supprimée<br>Erreur: ${error}` });
      });
  },

  getFileTypes() {
    return HTTP_BACK_OFFICE.get('/driver/deskrh/fileTypes/list')
      .then(data => data)
      .catch((error) => {
        console.log('catch ???');
        store.dispatch('app/openSnackbar', { message: `Un problème est survenu à la récupération des types de fichiers<br>Erreur: ${error}` });
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/lad/actions.js